/**
 * Class component based on:
 * https://dev.to/megazear7/the-vanilla-javascript-component-pattern-37la
 */
import {selectAll} from "../utils/utils";

export class ScrollAnimation {
    /**
     * ScrollAnimation Constructor
     * @param container
     * @returns {*}
     */
    constructor(container) {
        if (container) {
            this.init(container)
        }
    }

    /**
     * Initialize class
     * @param container
     */
    init(container) {
        this.container = container
        this.animate()
        window.addEventListener("scroll", this.animate)
    }

    /**
     * Animate contents
     */
     animate() {
        this.animationElement = selectAll('.animate')
        this.animationElement.forEach(el => {
            const windowHeight = window.innerHeight
            const elementTop = el.getBoundingClientRect().top
            const elementBottom = el.getBoundingClientRect().bottom
            const elementThreshold = el.dataset.threshold || 250
            const isVisible = elementTop < windowHeight && elementBottom > 0
            const isDesktop = window.innerWidth > 768

            let position = elementTop * 100 / windowHeight
            // Scrolling formula calculated by trial and error according to existing elements
            if (isVisible && isDesktop) {
                el.style.transform = `translateY(${position * elementThreshold / 100 + elementThreshold / 100}px)`
            } else if (isVisible) {
                el.style.transform = `translateY(${position * elementThreshold / 100 - elementThreshold / 100}px)`
            }
            
        })
    }
}

